"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    marko_component = {
        onCreate: function() {
          this.state = {
              collapsed: false
            };
        },
        onCollapse: function() {
          this.state.collapsed = !this.state.collapsed;
        }
      },
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/SubscriptionTable/components/Table/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Price_template = require("../../../../../components/Price/index.marko"),
    Price_tag = marko_loadTag(Price_template),
    Bx_template = require("../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    marko_forIn = require("marko/dist/runtime/helpers/for-in"),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    marko_attrs0 = {
        "class": "table-header"
      },
    marko_attrs1 = {
        "class": "position-absolute right-0 top-0 p-2 mx-3 my-1"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("436f69"),
    marko_node0 = marko_createElement("br", null, "11", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "table-body pb-2"
      },
    marko_attrs3 = {
        "class": "table-footer py-1"
      },
    marko_attrs4 = {
        "class": "font-small-3 text-muted"
      },
    marko_attrs5 = {
        "class": "text-success"
      },
    marko_attrs6 = {
        "class": "list-unstyled"
      },
    marko_attrs7 = {
        "class": "btn btn-black btn-xl btn-block"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const isStandard = input.type == 'standard'

  out.be("div", {
      "class": marko_classValue(marko_classValue([
        "shadow-lg px-3 py-2",
        isStandard ? "bg-black" : false
      ]))
    }, "0", component, null, 1);

  out.be("div", marko_attrs0, "1", component);

  out.be("h4", {
      "class": marko_classValue(isStandard ? "white-text" : false)
    }, "2", component, null, 1);

  Locale_tag({
      text: input.type.toCapitalCase()
    }, out, __component, "3");

  out.ee();

  if (input.price) {
    out.be("p", null, "4", component);

    Price_tag({
        amount: input.price,
        currency: "$",
        class: "font-medium-5 text-success"
      }, out, __component, "5");

    out.e("span", marko_attrs4, "6", component, 2)
      .t("/")
      .t(input.per, component);

    out.ee();
  } else {
    out.be("p", marko_attrs5, "7", component);

    Locale_tag({
        text: "More custom features",
        class: "font-medium-2"
      }, out, __component, "8");

    out.ee();
  }

  out.be("span", marko_attrs1, "9", component, null, 0, {
      onclick: __component.d("click", "onCollapse", false)
    });

  Bx_tag({
      type: "chevron-" + (state.collapsed ? "up" : "down"),
      class: "font-large-2 text-muted cursor-pointer"
    }, out, __component, "10");

  out.ee();

  out.n(marko_node0, component);

  out.ee();

  out.be("div", marko_attrs2, "12", component);

  if (state.collapsed) {
    out.be("ul", marko_attrs6, "13", component);

    marko_forIn(input.table, function(key, label) {
      var $keyValue$0 = "@" + key,
          $keyScope$0 = "[" + ($keyValue$0 + "]");

      out.be("li", {
          "class": marko_classValue(marko_classValue([
            "py-50",
            isStandard ? "white-text" : false
          ]))
        }, $keyValue$0, component, null, 1);

      Locale_tag({
          text: label
        }, out, __component, "14" + $keyScope$0);

      out.ee();
    });

    marko_forOf(input.common, function(label, index) {
      var $keyValue$1 = "@" + index,
          $keyScope$1 = "[" + ($keyValue$1 + "]");

      out.be("li", {
          "class": marko_classValue(marko_classValue([
            "py-50",
            isStandard ? "white-text" : false
          ]))
        }, $keyValue$1, component, null, 1);

      Locale_tag({
          text: label
        }, out, __component, "15" + $keyScope$1);

      out.ee();
    });

    out.ee();
  }

  out.ee();

  out.be("div", marko_attrs3, "16", component);

  if (input.price) {
    out.be("button", {
        "class": marko_classValue(marko_classValue([
          "btn btn-xl btn-block",
          isStandard ? "btn-success" : "btn-black"
        ]))
      }, "17", component, null, 1, {
        onclick: __component.d("click", () => component.emit('subscribe'), false)
      });

    Locale_tag({
        text: "Subscribe"
      }, out, __component, "18");

    out.ee();
  } else {
    out.be("button", marko_attrs7, "19", component);

    Locale_tag({
        text: "Contact sales"
      }, out, __component, "20");

    out.ee();
  }

  out.ee();

  out.ee();
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
